"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionConfirmation = void 0;
const tslib_1 = require("tslib");
const base_1 = tslib_1.__importDefault(require("../base"));
const utils_1 = tslib_1.__importDefault(require("../utils"));
class TransactionConfirmation extends base_1.default {
    createAndConfirmTransaction(username, tx_payload, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            const nonce = (options === null || options === void 0 ? void 0 : options.nonce) || utils_1.default.encoding.bufferToBase64(utils_1.default.encoding.randomBytes(16));
            const response = yield utils_1.default.http.post(this._baseURL, '/api/tx', {
                client_id: this._clientID,
                tx_payload,
                nonce
            }, headers);
            return yield this.confirmTransaction(username, response.id);
        });
    }
    confirmTransaction(username, tx_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const initResponse = yield utils_1.default.http.post(this._baseURL, '/api/tx/init', {
                client_id: this._clientID,
                username,
                tx_id,
                tx_type: "text"
            });
            const publicKey = initResponse.assertion_options;
            const { challenge } = publicKey;
            publicKey.challenge = utils_1.default.encoding.base64ToBuffer(publicKey.challenge);
            if (publicKey.allowCredentials) {
                for (const credential of publicKey.allowCredentials) {
                    credential.id = utils_1.default.encoding.base64ToBuffer(credential.id);
                }
            }
            const credential = yield utils_1.default.navigator.getCredential({ publicKey });
            const completeResponse = credential.response;
            const assertionPayload = {
                username,
                tx_id,
                client_id: this._clientID,
                challenge: challenge,
                key_handle: utils_1.default.encoding.bufferToBase64(credential.rawId),
                client_data: utils_1.default.encoding.bufferToBase64(completeResponse.clientDataJSON),
                auth_data: utils_1.default.encoding.bufferToBase64(completeResponse.authenticatorData),
                sign_data: utils_1.default.encoding.bufferToBase64(completeResponse.signature),
            };
            return yield utils_1.default.http.post(this._baseURL, "/api/tx/complete", assertionPayload);
        });
    }
}
exports.TransactionConfirmation = TransactionConfirmation;
exports.default = TransactionConfirmation;
//# sourceMappingURL=index.js.map